import { Card } from '../../../Common/Charts/Card';
import { number } from '../../../Common/Util/number';
import { useIdentificationChartsDataContext } from './hooks/useIdentificationChartsDataContext';
import './styles/Charts.css';

export const Indicators = () => {
    const { chartData } = useIdentificationChartsDataContext();

    return (
        <div className="identification-indicators-container-dashboard">
            <Card
                title="Total de Nascidos Vivos"
                value= {number.formatToBRNumber(
                    chartData?.indicators?.liveBirths || 0
                )}
            />
            <Card
                title="Total de Nascidos Vivos com Anomalias"
                value={number.formatToBRNumber(
                    chartData?.indicators?.liveBirthsWithAnomalies || 0
                )}
            />
        </div>
    );
};
